export const QUALITY_USER_BADGE_STATUS_TYPES = {
  /** 뉴비 뱃지 */
  NOT_ACHIEVED_NEWBIE: 'NOT_ACHIEVED_NEWBIE',
  /** 미획득 */
  NOT_ACHIEVED: 'NOT_ACHIEVED',
  /** 획득 */
  ACHIEVED: 'ACHIEVED',
} as const;

export type DTOQualityUserBadgeStatus =
  (typeof QUALITY_USER_BADGE_STATUS_TYPES)[keyof typeof QUALITY_USER_BADGE_STATUS_TYPES];

export interface DTOQualityUserBadge {
  /** 뱃지 보유 상태 (뉴비, 미획득, 획득) */
  state: DTOQualityUserBadgeStatus;

  /** 뱃지 획득을 위한 점수 누적률 */
  percentage: number;

  /** state에 따른 뱃지 이미지 URL */
  badgeImageUrl: string;
}

export interface DTOQualityUserBadgeState {
  state: DTOQualityUserBadgeStatus;
  headerImageUrl: string;
  headerTitle: string;
  headerContent: string;
  badgeImageUrl: string;
}
